import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { api, StandingRow } from '../api/client';
import { useAsync, Async } from '../components/Async';
import { Flag } from '../components/TeamBadge';
import { teamName } from '../lib/flags';
import { useStore } from '../stores/store';
import { H2 } from '../components/ui';

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  background: ${({ theme }) => theme.colors.surface};
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.radius};
  overflow: hidden;
  margin-bottom: 16px;
  font-size: 0.85rem;

  th, td {
    padding: 8px 6px;
    text-align: center;
  }
  th {
    background: ${({ theme }) => theme.colors.surfaceAlt};
    color: ${({ theme }) => theme.colors.textMuted};
    font-size: 0.72rem;
  }
  td.team {
    text-align: left;
    font-weight: 600;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 130px;
  }
  td.pts { font-weight: 800; }
`;

// Las dos primeras de cada grupo clasifican directo (zona verde).
const Row = styled.tr<{ $qualifies: boolean; $fav: boolean }>`
  background: ${({ theme, $fav }) => ($fav ? theme.colors.surfaceAlt : 'transparent')};
  border-left: 3px solid
    ${({ theme, $qualifies }) => ($qualifies ? theme.colors.accent : 'transparent')};
`;

export function Groups() {
  const state = useAsync(() => api.groups(), []);
  const navigate = useNavigate();
  const favorite = useStore((s) => s.favorite);

  return (
    <Async state={state}>
      {(d) =>
        d.groups.map((g) => (
          <section key={g.group}>
            <H2>Grupo {g.group}</H2>
            <Table>
              <thead>
                <tr>
                  <th>#</th>
                  <th style={{ textAlign: 'left' }}>Selección</th>
                  <th>PJ</th>
                  <th>DG</th>
                  <th>Pts</th>
                </tr>
              </thead>
              <tbody>
                {g.table.map((r: StandingRow) => (
                  <Row
                    key={r.team}
                    $qualifies={r.position <= 2}
                    $fav={r.team === favorite}
                    onClick={() => navigate(`/team/${encodeURIComponent(r.team)}`)}
                  >
                    <td>{r.position}</td>
                    <td className="team">
                      <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <Flag team={r.team} size={18} />
                        {teamName(r.team)}
                      </span>
                    </td>
                    <td>{r.pj}</td>
                    <td>{r.dg > 0 ? `+${r.dg}` : r.dg}</td>
                    <td className="pts">{r.pts}</td>
                  </Row>
                ))}
              </tbody>
            </Table>
          </section>
        ))
      }
    </Async>
  );
}
